// extracted by mini-css-extract-plugin
export var button = "_d5-4";
export var hasDarkBackground = "_d5-7";
export var hasLightBackground = "_d5-6";
export var iconWrapper = "_d5-0";
export var large = "_d5-2";
export var medium = "_d5-1";
export var small = "_d5-5";
export var xsmall = "_d5-3";